<template>
  <div>
    <div class="py-10 max-w-4xl mx-auto px-3 text-center">
      <p class="text-2xl font-bold pb-3 mb-10 text-center border-b border-gray-300">
        CSSNLP 2020 组织委员会
      </p>
      <div v-for="(values, position) in name_list" :key="position" class="py-6 max-w-md mx-auto">
        <p class="font-bold text-xl text-blue-900">{{ position }}</p>
        <div class="flex flex-wrap justify-center mt-1">
          <p
            class="mx-3 mt-2 flex flex-col justify-center"
            v-for="(one, index) in values"
            :key="one + index"
          >
            <span class="font-bold">{{ one.name }}</span>
            <span class="text-gray-700 text-xs"> {{ one.affiliation }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>>

<script>


export default {
  metaInfo: {
    title: "组委会"
  },
  data() {
    return {
      name_list: {
        大会主席: [
          {
            name: '冯洋',
            affiliation: '中科院计算所',
          },
        ],
        程序委员会主席: [
          {
            name: '张绍磊',
            affiliation: '中科院计算所',
          },
        ],
        组委会成员: [
          {
            name: '张绍磊',
            affiliation: '中科院计算所',
          },
          {
            name: '高珲',
            affiliation: '天津大学',
          },
          {
            name: '曹鹏飞',
            affiliation: '中科院自动化所',
          },
          {
            name: '马聪',
            affiliation: '中科院自动化所',
          },
          {
            name: '王雪松',
            affiliation: '哈尔滨工业大学',
          },
          {
            name: '吴珂',
            affiliation: '国际关系学院',
          },
          {
            name: '王思远',
            affiliation: '复旦大学',
          },
          {
            name: '李军毅',
            affiliation: '中国人民大学',
          },
          {
            name: '朱芮',
            affiliation: '武汉大学',
          },
          {
            name: '洪鑫',
            affiliation: '中科院计算所',
          },
          {
            name: '王克重',
            affiliation: '海南大学',
          },
          {
            name: '姚远',
            affiliation: '清华大学',
          },
          {
            name: '孙凯',
            affiliation: '北京航空航天大学',
          },
        ],
      },
    };
  },
  methods: {
    sort_by_name: function(list) {
      return list.sort((x, y) => { return x.name.localeCompare(y.name)});
    }
  }
};
</script>